// TODO make separate file for this
function jumpToRequired( $ ) {

  let isFormValid

  // Scroll function to the first empty required field
  function scrollToEmptyRequiredField() {
    $('html, body').animate({
      scrollTop: $('.invalid').first().offset().top
    }, 500);
  }
  
  // Function which checks if all the required fields are filled
  function checkAllRequiredFields() {
    $('.wpcf7-validates-as-required').each(function() {
      const $requiredField = $(this);
      let emptyField = $.trim($requiredField.val());
      if(emptyField.length > 0) {
        $requiredField.removeClass('invalid');
      } else {
        $requiredField.addClass('invalid');
        isFormValid = false;
      }
    });
  }
  
  // On submit show popup if the all fields are filled
  $('.wpcf7-form').on('submit', function(e) {
    
    // e.preventDefault();     
    isFormValid = true;
    checkAllRequiredFields();
    
    if(!isFormValid) {     
      scrollToEmptyRequiredField();
    } 
  });
}

export default jumpToRequired;